/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextField } from "@mui/material";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import LabelledField from "components/labelled-field";
import { useTranslation } from "react-i18next";
import { FeatureWebpageComponentEditWrapper } from "./component-feature-webpage-wrapper";
import { WebpageCard } from "./webpage-card";
import { WebpageCardType } from "./webpage-card-type";

const FeatureWebpageComponentEditor = () => {

    const { t } = useTranslation();
    const { component, update, updateFactory } = useUpdateComponent();

    const {
        style,
        title,
        webpages,
    } = component;

    const webpageCard = component.webpageCard || "fixed";
    
    const onChangeTitle = (event) => {
        const title = event.target.value;
        update("title", title);
    };
    const onChangeCardType = updateFactory("webpageCard");
    const onChangeList = updateFactory("webpages");
    
    return (
        <div className='simplicity-editor-frame'>
            <LabelledField label={`${t("commons.title")} :`}>
                <TextField
                    id='section_list_title'
                    fullWidth={true}
                    value={title}
                    placeholder={t("commons.addTitleOptional")}
                    onChange={onChangeTitle}
                />
            </LabelledField>
            <LabelledField label={t("commons.presentationStyle")} style={{ paddingTop: 6, marginTop: 12 }}>
                <WebpageCardType
                    webpageCard={webpageCard}
                    onChangeCardType={onChangeCardType}
                />
            </LabelledField>
            <FeatureWebpageComponentEditWrapper
                webpages={webpages}
                onChangeList={onChangeList}
                style={style}
            >
                <WebpageCard />
            </FeatureWebpageComponentEditWrapper>
        </div>
    );
};
FeatureWebpageComponentEditor.displayName = "FeatureWebpageComponentEditor";
export { FeatureWebpageComponentEditor };
